import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { NumericFormat } from 'react-number-format'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
  padding-left: 50px;
`

export const Header = styled.div`
  padding: 12px 20px;
  background-color: #FFFFFF;
  flex-direction: row;
  justify-content: center;
`

export const InfoContainer = styled.div`
  display: flex;
  min-width: 480px;
  width: 640px;
  box-shadow: 0px 2px 10px -6px #252525;
  border-radius: 15px;
  flex-direction: column;
  justify-content: space-between;
  padding: 8px 15px !important;
  margin-bottom: 10px;
`

export const DayContainer = styled(Link)`
  min-width: 920px;
  width: 980px;
  height: 40px;
  display: grid;
  grid-template-columns: ${({bonuses, discounts, showTotalEarnings, showBusinessEarnings}) => {
    let numColumns = 2
    if (showTotalEarnings) numColumns++
    if (showBusinessEarnings) numColumns++
    if (bonuses?.length > 0) numColumns++
    if (discounts?.length > 0) numColumns++
    return `150px repeat(${numColumns}, 1fr) 20px`
  }};
  box-shadow: 0px 2px 10px -6px #252525;
  border-radius: 15px;
  justify-content: space-between;
  align-items: center;
  justify-items: center;
  padding: 8px 15px !important;
  margin-bottom: 10px;
  text-decoration: none;

  &:hover { background-color: #F7F7F7; }

  b {
    color: #000000;
    margin-bottom: 3px;
  }

  p {
    &:first-child {
      justify-self: flex-start;
    }
  }
`

export const ListContainer = styled(Container)`
  padding: 15px 0px 30px;
`

export const TabStickyContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 40px;
  background-color: #FFFFFF;
  margin-bottom: 0px;
  position: sticky;
  top: 0px;
  z-index: 3;
`

export const RegisterColumn = styled(Container)`
  width: 50%;
  height: 100%;
  padding: 15px 20px 0px 0px;
  align-items: flex-start;
  border-left: 1px solid #E0E0E0;

  &:first-child {
    border-left: 0px;
    padding-right: 0px;
  }
`

export const Info = styled(InfoContainer)`
  margin: 0px;
  padding: 0px !important;
  border: 0px;
  box-shadow: none;
  width: 100%;
`

export const FilterContainer = styled(Info)`
  display: grid;
  grid-template-columns: 9fr 9fr 9fr 10fr;
  margin-bottom: 10px;
  column-gap: 10px;
  min-width: 840px;
  width: 920px;
  height: auto;
`

export const ErrorContainer = styled.div`
  padding: 9px;
  margin: 15px 0px;
  width: 100%;
  border-radius: 15px;
  align-items: center;
  background-color: #FF3939;
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`

export const InfoRow = styled(Row)`
  width: 100%;
`

export const LabelRow = styled.div`
  display: grid;
  grid-template-columns: ${({bonuses, discounts, showTotalEarnings, showBusinessEarnings}) => {
    let numColumns = 2
    if (showTotalEarnings) numColumns++
    if (showBusinessEarnings) numColumns++
    if (bonuses?.length > 0) numColumns++
    if (discounts?.length > 0) numColumns++
    return `150px repeat(${numColumns}, 1fr) 20px`
  }};
  justify-content: center;
  align-items: flex-end;
  justify-items: center;
  margin-bottom: 7px;
  padding: 0px 15px;
  min-width: 920px;
  width: 980px;

  p {
    &:first-child {
      justify-self: flex-start;
      margin-left: 25px;
    }
  }
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
  margin-bottom: 0px;
`

export const Title = styled.h2`
  font-size: 16px;
  font-weight: 500;
  margin: 7px 0px 0px;
  align-self: center;
`

export const SubTitle = styled(InfoText)`
  font-weight: bold;
`

export const LinkButton = styled(Link)`
  color: #35A7FF;
  font-weight: bold;
  text-decoration: none;
  font-size: 14px;

  &:hover {
    color: #35A7FF88;
  }
`

export const MoneyTextMask = styled(NumericFormat).attrs (props => {
  return {
    value: props.value.toFixed (2).replace ('.', ','),
    thousandSeparator: '.',
    decimalSeparator: ',',
    displayType: 'text',
    prefix: 'R$ '
  }
})`
  color: ${({value}) => parseFloat (value.replace (',', '.')) >= 0 ? '#44CF6C' : '#FF3939'};
  font-size: 16px;
  font-weight: bold;
  line-height: 14px;
  margin-bottom: 0px;
  padding: 0px;
`
